import { getRoutePathWithId } from '@/utils/router-utils';
export class SharedRoutes {
  static ROOT = '';
  static UNVERIFIED = '/unverified';
  static UNAUTHORIZED = '/unauthorized';
  static LOGOUT = '/logout';
  static LOGIN = '/login';
  static REGISTER = '/register/account';
  static RESET_PASSWORD = '/reset-password';
  static EMAIL_VERIFIED = '/register/verified';
  static INVITATION_CODE = '/invite/:id';
}

export const getSharedRoute = (path: string, id?: string) => {
  const fullPath = `${SharedRoutes.ROOT}${path}`;
  if (id) {
    return getRoutePathWithId(fullPath, id);
  }
  return fullPath;
};
